<div
    class="app-widget h-100"
    [ngClass]="configuration.hostPresentationClass"
    [@widgetEntrance]="{
        value: '',
        params: { delay: delayIndex * 100, duration: 300 }
    }"
>
    <div class="header d-flex">
        <app-widget-header-detail-material
            class="mr-auto p-2"
            [title]="configuration.componentData.title"
            [detail]="detail"
            [icon]="configuration.componentData.icon"
            [isSectionHeader]="false"
        ></app-widget-header-detail-material>
        <div class="p-2 row group-tools align-items-center">
            <ng-container
                *ngFor="let item of configuration.componentData.export"
            >
                <div class="flex-row justify-content-between pr-3">
                    <app-button-icon
                        class="mr-2"
                        *ngIf="
                            item.hasChangeView &&
                            configuration.componentData.title === 'asarco_state'
                        "
                        [image]="'panel-view-icon'"
                        [iconType]="'icon'"
                        [apiSource]="item.source"
                        [spinner]="null"
                        [disabled]="null"
                        (clickHandler)="changeViewClassToggler()"
                    ></app-button-icon>
                    <app-button-icon
                        class="mr-2"
                        *ngIf="item.hasDownload"
                        [image]="'download'"
                        [iconType]="'icon'"
                        [apiSource]="item.source"
                        [spinner]="null || btnSpinner"
                        [disabled]="
                            null ||
                            disabledExcelBtn ||
                            noDataVisibility ||
                            errorVisibility ||
                            downloadDisable
                        "
                        (clickHandler)="downloadExcel()"
                    ></app-button-icon>
                    <app-button-icon
                        [ngClass]="{ rotated: showHasTable }"
                        *ngIf="item.hasTable"
                        [image]="'wrap-down'"
                        [iconType]="'icon'"
                        [apiSource]="item.source"
                        [spinner]="null"
                        [disabled]="null"
                        (click)="tableClassToggler()"
                    ></app-button-icon>
                </div>
            </ng-container>
        </div>
    </div>
    <!-- Spinner como vista predeterminada -->
    <app-spinner
        [@showHide]="visibility && !noDataVisibility && !errorVisibility"
    ></app-spinner>

    <!-- No data -->
    <app-no-data-message
        [@showNoData]="noDataVisibility && !visibility && !errorVisibility"
    ></app-no-data-message>

    <!-- Error -->
    <app-error-default
        [@showError]="errorVisibility && !visibility && !noDataVisibility"
    ></app-error-default>

    <!-- Vista de widgets mostrar solo cuando no está spinner, error y nodata -->
    <div
        [@showHide]="!visibility && !noDataVisibility && !errorVisibility"
        class="content"
        [ngClass]="{ fixed: configuration.componentData.staticHeight }"
    >
        <app-progress-bar></app-progress-bar>

        <ng-template component-host></ng-template>
    </div>
</div>
